module.exports = __webpack_public_path__ + "img/close.b056d319.png";